import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { UserData } from "../../@core/data/users";

@Component({
  selector: "ngx-view-user-card",
  styleUrls: ["./view-user-card.component.scss"],
  templateUrl: "./view-user-card.component.html",
})
export class ViewUserCardComponent implements OnInit {
  @Input() userData: UserData;
  @Input() mode?: string; //stars / hearts / noLiked
  @Output() onRedirect: EventEmitter<any> = new EventEmitter();

  constructor(private router: Router) {}

  ngOnInit(): void {}

  onClick() {
    //this.onRedirect.emit(true);
  }
}
